import styled, { css } from 'styled-components';

import { ButtonV2 } from '@getgrover/ui';
import CloseIcon from 'ggApp/shared/icons/close';
import { LineItemCard } from 'ggApp/modules/newCheckout/components/LineItemCard';
import Circle from 'ggApp/shared/components/CircleLoader/CircleLoader';
import { CardWithProductMapper } from 'ggApp/shared/components/cards/widgetProductCard';
import omitProps from 'ggApp/utils/omitProps';

export const Container = styled(omitProps('loading')('div'))`
    position: relative;
    border-radius: 8px;
    border: 2px solid ${(props) => props.theme.colors.Color2_75};
    padding: 16px;
    display: flex;
    flex-direction: column;

    ${({ loading }) =>
        loading &&
        css`
            pointer-events: none;
        `}
`;

export const Close = styled(CloseIcon)`
    cursor: pointer;
    &:hover > path {
        fill: ${({ theme }) => theme.colors['Level 3']};
    }
`;

export const CloseIconWrap = styled.div`
    position: absolute;
    right: 16px;
    top: 16px;
`;

export const ProductCard = styled(LineItemCard)`
    padding-bottom: 8px;
    max-width: 96%;
    border: none;
`;

export const Description = styled.p`
    ${(props) => props.theme.typography.TinyParagraph};
    color: ${(props) => props.theme.colors.Color2_75};
`;

export const Button = styled(ButtonV2)``;

export const CircleLoader = styled(Circle)`
    position: absolute;
    transform: scale(0.6);
`;

export const Cart = styled(CardWithProductMapper)`
    min-width: 312px;
    max-width: 312px;
    margin-right: 16px;
    margin-bottom: 16px;
`;

export const ButtonWrap = styled.div`
    display: flex;
    width: max-content;
    margin-top: 8px;
    position: relative;
`;

export const CloseButton = styled(ButtonV2)`
    position: absolute;
    z-index: 1;
    right: ${({ theme }) => theme.spacers.L};
    top: ${({ theme }) => theme.spacers.XL};
`;
